import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  Box,
  TextField,
  Grid,
  FormGroup,
  FormControlLabel,
  Switch,
  Button,
  Stack,
  InputAdornment,
} from "@mui/material";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // Ensure Firebase is properly initialized

import DropDownPayment from "../components/DropDownPayment";
import DropDown from "../components/Dropdown";

function PaymentForm({ formData, setFormData }) {
  const [checked, setChecked] = React.useState(false); // For credit switch
  const [memberData, setMemberData] = React.useState([]);
  const [sportData, setSportData] = React.useState([]);

  useEffect(() => {
    // Fetch members from Firestore
    const fetchMembers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "members"));
        const members = querySnapshot.docs.map((doc) => doc.data());
        setMemberData(members);
      } catch (error) {
        console.error("Error fetching members: ", error);
      }
    };

    // Fetch sport types from Firestore
    const fetchSportTypes = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "sportTypes"));
        const sports = querySnapshot.docs.map((doc) => doc.data());
        setSportData(sports);
      } catch (error) {
        console.error("Error fetching sport types: ", error);
      }
    };

    fetchMembers();
    fetchSportTypes();
  }, []);

  const monthsData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <div>
      <Box sx={{ mt: 3 }}>
        <Grid container spacing={5}>
          <Grid item xs={12} sm={6}>
            <DropDown
              names={memberData}
              data={formData}
              setData={setFormData}
              ismember
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Stack spacing={0.5}>
              <DropDownPayment
                names={sportData}
                data={formData}
                setData={setFormData}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6}>
            <DropDownPayment
              months
              names={monthsData}
              data={formData}
              setData={setFormData}
            />
          </Grid>
          <Grid item xs={12} sm={6} />

          <Grid item xs={12} sm={6}>
            <TextField
              label="Total Amount"
              id="total"
              type="number"
              value={formData.amount || ""}
              onChange={(e) =>
                setFormData({ ...formData, amount: Number(e.target.value) })
              }
              sx={{ m: 0, width: "25ch" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">DHS</InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              disabled={!checked}
              label="Credit"
              id="credit"
              type="number"
              onChange={(e) =>
                setFormData({ ...formData, credit: Number(e.target.value) })
              }
              sx={{ m: 0, width: "20ch" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">-DHS</InputAdornment>
                ),
              }}
            />
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={checked}
                    onChange={(event) => {
                      setChecked(event.target.checked);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Credit"
              />
            </FormGroup>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default PaymentForm;

PaymentForm.propTypes = {
  formData: PropTypes.object,
  setFormData: PropTypes.func,
};
